import { ServerTable } from "vue-tables-2";
import Vue from "vue";
import i18n from "../i18n";

let _t = q => i18n.i18next.t(q);

let serverTableOptions = {
    texts: {
        count: _t("components:serverTable.count"),
        first: _t("components:serverTable.count"),
        last: _t("components:serverTable.last"),
        filter: _t("components:serverTable.filter"),
        filterPlaceholder: _t("components:serverTable.filterPlaceholder"),
        limit: _t("components:serverTable.limit"),
        noResults: _t("components:serverTable.records"),
        filterBy: _t("components:serverTable.filterBy"),
        loading: _t("components:serverTable.loading"),
        defaultOption: _t("components:serverTable.defaultOption"),
        columns: _t("components:serverTable.columns")
    }
};
Vue.use(ServerTable, serverTableOptions, false, "bootstrap4");
